module.exports = __webpack_public_path__ + "img/vki.4ae47684.png";